<template>
  <div>
    <selectList
      v-model="itemSelected"
      :accessConfirm="$access.version.edit"
      :accessDelete="$access.version.delete"
      :selectLabel="$t('entities.version.props.code')"
      :items="value"
      :index="indexSelected"
      @newItem="edit(getModelDefault(), null, true)"
      @selectChange="edit($event, value.indexOf($event), true)"
      @delete="remove(indexSelected)"
      @confirm="confirm(true, $refs.form.isValid())"
      :loading="loading"
      :confirmButton="itemSelected != null"
      itemText="code"
      itemValue="code"
      @saveChanges="saveChanges"
    >
      <versionForm ref="form" v-if="itemSelected" v-model="itemSelected" />
    </selectList>
  </div>
</template>

<script>
import versionForm from "@/components/forms/versions/versionForm";
import objectValueListMixing from "@/mixins/objectPageLists/objectValueListMixing.js";
import selectList from "@/components/selectLists/selectList";
export default {
    props: ["value"],
    components: {
        versionForm,
        selectList
    },
    mixins: [objectValueListMixing],
    data() {
        return {
            loading: false,
            itemSelected: null
        };
    },
    watch: {
        itemSelected() {
          let index =  this.value.indexOf(this.itemSelected);
           this.indexSelected =  index < 0 ? null : index;
        }
    },
    methods: {
        saveChanges() {
          if(!this.itemSelected) return true;
            let isValid = this.$refs.form ? this.$refs.form.isValid() : true;
            if (isValid) {
                this.confirm(true, isValid)
                this.itemSelected = null;
                return true;
            }
            return false;

        },
        getModelDefault() {
            return {
                code: this.value.length + 1,
                description: "",
                stages: [],
                itemId: null
            };
        }
    }
};
</script>
